import SacrificerServices from '../../services/pilgrimage/sacrificer';

export const state = {
    sacrificers: [],
    sacrificer: {},
}

export const mutations = {
    setSacrificer(state, sacrificer) {
        state.sacrificer = sacrificer
    },
    setSacrificers(state, sacrificers) {
        state.sacrificers = sacrificers
    }
}

export const getters = {
    getSacrificer(state) {
        return state.sacrificer;
    },
    getSacrificers(state) {
        return state.sacrificers;
    },
}

export const actions = {
    get({commit}, id){
        return SacrificerServices.get(id)
        .then((response)=>{
            commit('setSacrificer', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return SacrificerServices.getAll(data)
        .then((response)=>{
            commit('setSacrificers', response.data.data)
            return response
        })
    },
    delete({state, commit}, id){
        return SacrificerServices.delete(id)
        .then((response)=>{
            commit('setSacrificers', state.sacrificers.filter((x)=>x.id != id))
            return response
        })
    },
}